<template>
	<div>
		<div class="bjMy">
			<div class="message">
				<div class="mess-img" @click="layoutClick">
					<img src="@/assets/Group 1271@2x.png" style="height: 35px; width: 35px" />
				</div>
				<div>
					<div class="message-title">请写入签名</div>
				</div>
				<div class="message-border"></div>
				<div class="vue-esing">
					<vue-esign ref="esign" :width="484" :height="192" :isCrop="isCrop" :lineWidth="lineWidth" :lineColor="lineColor" :bgColor.sync="bgColor" />
				</div>
				<div class="flex-save">
					<div class="clear" @click="handleReset">清除</div>
					<div class="save" @click="handleGenerate">保存</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import vueEsign from 'vue-esign';
let isCrop = ref(false);
let lineWidth = ref(6);
let lineColor = ref('#000000');
let bgColor = ref('#F7F2EE');
let resultImg = ref('');
let esign = ref('');
let emit = defineEmits(['singnClick',"singfklaintoa"]);

const handleReset = () => {
	esign.value.reset();
};

const handleGenerate = () => {
	esign.value.generate({ format: 'png', quality: 0.8 }).then((res) => {
		emit('singfklaintoa', res);
	});
};

const layoutClick = () => {
	emit('singnClick');
};
</script>

<style lang="scss">
.bjMy {
	position: fixed;
	width: 100%;
	height: calc(100% - 70px);
	background: rgba(0, 0, 0, 0.7);
	z-index: 1000;
	bottom: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}

.message {
	width: 532px;
	height: 365px;
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
	position: relative;
}

.mess-img {
	position: absolute;
	right: -15px;
	top: -15px;
}

.message-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 20px;
	color: #333333;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-top: 21px;
}
.message-border {
	width: 100%;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-top: 11px;
}

.slicess {
	padding: 0px 40px;
}
.slicess-padd {
	margin-top: 22px;
}

.title-sliceS {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}
.title-time1 {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-top: 7px;
}

.pagination-contact1 {
	position: absolute;
	bottom: 30px;
	left: 50px;
}

.user-nickname {
	width: 310px;
	height: 42px;
	border-radius: 4px 4px 4px 4px;
	border: 1px solid #eeeeee;
	margin-left: 22px;
	margin-top: 24px;
	display: flex;
}

.flex-nickname {
	display: flex;
	align-items: center;
}

.inputClat {
	border: none;
	width: 200px;
	margin-left: 5px;
	font-size: 16px;
}

.inputClat::placeholder {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #777777;
	font-style: normal;
	text-transform: none;
}

.inputClat:focus {
	outline: none;
	border: none;
}

.name-assets {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}

.sure-you-want {
	width: 310px;
	height: 52px;
	background: #ff3333;
	border-radius: 4px 4px 4px 4px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #ffffff;
	line-height: 52px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-top: 32px;
	margin-left: 24px;
}

.vue-esing {
	margin-left: 20px;
	margin-top: 15px;
	background-color: #f7f2ee;
	width: 484px;
}

.flex-save {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 22px;
}
.clear {
	width: 150px;
	height: 52px;
	background: #ffffff;
	border-radius: 4px 4px 4px 4px;
	border: 1px solid #ff3333;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #ff3333;
	line-height: 52px;
	text-align: center;
	font-style: normal;
	text-transform: none;
}
.save {
	width: 150px;
	height: 52px;
	background: #ff3333;
	border-radius: 4px 4px 4px 4px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #ffffff;
	line-height: 52px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-left: 10px;
}
</style>
